














import { computed, defineComponent, inject, Ref } from '@nuxtjs/composition-api';
import { ProductData } from '~/features/product';
import { PRODUCT_CONTEXT } from '~/utils/provides';

export default defineComponent({
  name: 'ProductGroupItemCustomizer',
  setup() {
    const product = inject(PRODUCT_CONTEXT) as Ref<ProductData>;

    const items = computed(() => {
      return product.value.groupItems;
    });

    return {
      items,
    };
  },
});
